import { Injectable } from '@angular/core';
import { CanActivate, GuardResult, ActivatedRouteSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { PermissionService } from 'src/services/permission.service';
import { AuthService } from 'src/services/auth.service';
import { MenuService } from 'src/services/menu.service';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(
    private navController: NavController,
    private toastService: ToastService,
private globalService: GlobalService,
    private permissionService: PermissionService,
    private authService: AuthService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<GuardResult> {
    const access = route.data['access'];
    if (!access) return true;

    const permissions = await this.permissionService.waitForPermissions();
    if (permissions.module.includes(access)) {
      return true;
    }

    if (this.authService.profile$.getValue()) {
      this.toastService.showToast({
        summary: `Kamu tidak memiliki akses ke modul tersebut`,
        detail: 'Jika kamu merasa ini adalah kesalahan, hubungi HR kami',
        severity: 'error',
      });
      return true;
    }

    setTimeout(() => this.navController.navigateBack('/restricted'), 300);
    return false;
  }
}

@Injectable({
  providedIn: 'root',
})
export class RedirectPermissionGuard implements CanActivate {
  constructor(
    private navController: NavController,
    private menuService: MenuService,
  ) {}

  async canActivate(): Promise<GuardResult> {
    const link = await this.menuService.getAfterLoginPage();
    if (link === '/restricted') return true;
    return this.navController.navigateForward([link]);
  }
}
